export class EntraRestoreReportSummaryRequiredActionScopeCounts {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoredObject",
            "baseName": "restoredObject",
            "type": "number",
            "format": ""
        },
        {
            "name": "dependents",
            "baseName": "dependents",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportSummaryRequiredActionScopeCounts.attributeTypeMap;
    }
    constructor() {
    }
}
